import { render, staticRenderFns } from "./DashboardUFIS.vue?vue&type=template&id=4d22c20e&scoped=true"
import script from "./DashboardUFIS.vue?vue&type=script&lang=js"
export * from "./DashboardUFIS.vue?vue&type=script&lang=js"
import style0 from "./DashboardUFIS.vue?vue&type=style&index=0&id=4d22c20e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d22c20e",
  null
  
)

export default component.exports